// Use each picture's phone image at every screen size. The desktop slots of the phone-only blocks hold GemPages stock photos.
document.querySelectorAll('main picture').forEach(function(p){
  var m=p.querySelector('source[media*="767"]'),img=p.querySelector('img');
  if(!m||!img)return;
  var u=m.getAttribute('data-srcset')||m.getAttribute('srcset');
  if(!u||u.indexOf('data:')===0)return;
  p.querySelectorAll('source').forEach(function(s){if(s!==m)s.remove()});
  m.setAttribute('media','all');m.setAttribute('srcset',u);m.setAttribute('data-srcset',u);
  img.setAttribute('data-src',u);
  if(img.getAttribute('src')&&img.getAttribute('src').indexOf('data:')!==0)img.setAttribute('src',u);
});
